// extracted by mini-css-extract-plugin
export var borderRadius = "_fe-4";
export var large = "_fe-3";
export var logoContainer = "_fe-0";
export var nameLogo = "_fe-2";
export var small = "_fe-1";